module.exports = __webpack_public_path__ + "img/rank3.e8ad4bed.png";